<script lang="ts" setup>
import type { FCardData } from '@components/types'

defineProps<{
  card: FCardData
}>()
</script>

<template>
  <I18nLink
    :to="card.href"
    block
    w-full flex flex-col gap-16px justify-start items-center
    min-w-300px fubex-shadow-lg
    bg-gradient-to-br from-primary-300 via-primary-100 to-primary-200 rounded-xl text-primary-800
    dark="from-neutral-200 to-neutral-100"
    px-32px pb-32px
    lg:hover="scale-105 fubex-shadow-lg" duration-300
  >
    <NuxtImg v-if="card.img" :src="card.img" :alt="card.title" w-auto h-150px mt-48px />
    <h5 mt-32px mb-16px heading6 font-700 text-center dark:text-neutral-900>
      {{ card.title }}
    </h5>
    <p v-if="card.text" text-center paragraph-sm>
      {{ card.text }}
    </p>
    <FButton :name="`card-more-${card.key}`">
      {{ $t('components.showMoreInformation') }}
    </FButton>
  </I18nLink>
</template>
